import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

const getNotificationService = () => {
  return privateRequest.get(`${ConfEnv.API_URL.URL_NOTIFICATION}`);
};

export {getNotificationService};
